import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './commons/guards/auth.guard';
import { NotFoundComponent } from './modules/shared/components/not-found/not-found.component';
import { UnAuthGuard } from './commons/guards/unauth.guard';
import { RiderAuthGuard } from './commons/guards/rider.guard';
// Shared components
const routes: Routes = [

  {
    path: '',
    loadChildren: () => import("./modules/home/home.module").then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'delivery',
  //   loadChildren: () => import("./modules/delivery/delivery.module").then(m => m.DeliveryModule),
  // },
  // {
  //   path: 'gelataio',
  //   loadChildren: () => import("./modules/sweets/sweets.module").then(m => m.SweetsModule)
  // },
  {
    path: 'riders/orders',
    loadChildren: () => import('./modules/home/modules/orders/riders-orders/riders-orders.module').then(m => m.RidersOrdersModule),
    canActivate: [RiderAuthGuard]
  },
  {
    path: "login",
    loadChildren: () => import('./modules/login/login.module').then(mod => mod.LoginModule),
    canActivate: [UnAuthGuard]
   },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
